import React from 'react';
import { HStack, Text, Button } from '@chakra-ui/react';

const SignUpSection = ({ onSignUp }) => (
  <HStack justify="center" spacing={1} mb={2}>
    <Text color="gray.500" fontSize="sm">Don't have an account?</Text>
    <Button variant="link" colorScheme="blue" fontSize="sm" p={0} h="auto" onClick={onSignUp}>
      Sign Up
    </Button>
  </HStack>
);

export default SignUpSection; 